export interface CompanyConfig {
  name: string;
  subtitle: string;
}

export interface HeaderConfig {
  title: string;
  description: string;
}

export interface InsuranceItem {
  amount: string;
  description: string;
}

export interface InsuranceSection {
  title: string;
  items?: InsuranceItem[];
  amount?: string;
  description?: string;
}

export interface CertificateRequirements {
  title: string;
  items: string[];
}

export interface InsuranceConfig {
  [key: string]: InsuranceSection | CertificateRequirements | undefined;
  generalLiability: InsuranceSection;
  autoLiability: InsuranceSection;
  workersCompensation: InsuranceSection;
  professionalLiability: InsuranceSection;
  excessUmbrellaLiability?: InsuranceSection;
  excessLiability?: InsuranceSection;
  cyberLiability?: InsuranceSection;
  crimeLiability?: InsuranceSection;
  automobileLiability?: InsuranceSection;
  certificateRequirements?: CertificateRequirements;
}

export interface CertificateRequirementsConfig {
  title: string;
  items: string[];
}

export interface AdditionalInsured {
  name: string;
  address: string;
  isCertificateHolder?: boolean;
}

export interface AdditionalInsuredsConfig {
  title: string;
  items: AdditionalInsured[];
}

export interface FooterConfig {
  text: string;
  brand: string;
}

export interface ContentConfig {
  header: HeaderConfig;
  company: CompanyConfig;
  insurance: InsuranceConfig;
  certificateRequirements: CertificateRequirementsConfig;
  additionalInsureds: AdditionalInsuredsConfig;
  footer: FooterConfig;
}

export const contentConfig: ContentConfig = {
  header: {
    title: 'COI Uploader',
    description: 'Upload and preview your Certificate of Insurance documents.',
  },
  company: {
    name: 'Example Company',
    subtitle: 'Insurance requirements',
  },
  insurance: {
    generalLiability: {
      title: 'General Liability:',
      items: [
        { amount: '$2,000,000', description: 'General Aggregate' },
        { amount: '$1,000,000', description: 'Per Occurrence' },
        { amount: '$1,000,000', description: 'Products/Completed Operations' },
      ],
    },
    autoLiability: {
      title: 'Auto Liability:',
      amount: '$1,000,000',
      description: 'Combined Single Limit',
    },
    workersCompensation: {
      title: "Workers' Compensation:",
      description: 'Limits as established by each U.S. State',
    },
    professionalLiability: {
      title: 'Professional Liability:',
      amount: '$2,000,000',
    },
  },
  certificateRequirements: {
    title: 'Certificate requirements',
    items: [
      'Waiver of subrogation required for liability and workers compensation.',
      'Description of operations includes primary and non-contributory with any other available insurance.',
    ],
  },
  additionalInsureds: {
    title: 'Additional insureds',
    items: [
      {
        name: 'Example Company',
        address: '123 Main St, San Francisco, CA 94105',
        isCertificateHolder: true,
      },
      {
        name: 'Parent Company, Inc.',
        address: '456 Market St, San Francisco, CA 94103',
      },
    ],
  },
  footer: {
    text: 'Powered by',
    brand: '1099Policy',
  },
};
